import React, { useState, useEffect } from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import WrenchIcon from "src/assets/Wrench";
import CreditCardIcon from "src/assets/CreditCard";
import UserIcon from "src/assets/User";
import CartonBoxIcon from "src/assets/CartonBox";
import Config from "./Config";
import Products from "./Products";
import Orders from "./Orders";
import Customers from "./Customers";
import SyncReports from "./SyncReports";
import Logs from "src/assets/Logs";
import InventoryTransactions from "./InventoryTransactions";

export default function Bigcommerce() {
  const [activeVisible, setActiveVisible] = useState(false);
  const [activeTop, setActiveTop] = useState(0);

  useEffect(() => {
    sessionStorage.setItem("cartType", "bigcommerce");
  });

  const menuItems = [
    {
      name: "Setup",
      href: "/app/bigcommerce",
      icon: <WrenchIcon />,
      component: <Config />,
      exact: true,
    },
    {
      name: "Orders",
      href: "/app/bigcommerce/orders",
      icon: <CreditCardIcon />,
      component: <Orders />,
      exact: false,
    },
    {
      name: "Customers",
      href: "/app/bigcommerce/customers",
      icon: <UserIcon />,
      component: <Customers />,
      exact: false,
    },
    {
      name: "Products",
      href: "/app/bigcommerce/products",
      icon: <CartonBoxIcon />,
      component: <Products />,
      exact: false,
    },
    {
      name: "BigCommerce to Deskera Sync Report",
      href: "/app/bigcommerce/sync-to-deskera-report",
      icon: <Logs />,
      component: <SyncReports syncTo="DESKERA" />,
      exact: false,
    },
    {
      name: "Deskera to BigCommerce Sync Report",
      href: "/app/bigcommerce/sync-to-bigcommerce-report",
      icon: <Logs />,
      component: <SyncReports syncTo="ECOM" />,
      exact: false,
    },
    {
      name: "Inventory",
      href: "/app/bigcommerce/inventory",
      icon: <CartonBoxIcon />,
      component: <InventoryTransactions />,
      exact: false,
    },
  ];

  return (
    <>
      <div
        className="bg-white py-3 dk-shadow-sm"
        style={{
          minWidth: 240,
          borderRight: "1px solid rgba(0, 0, 0, 0.1)",
          zIndex: 9,
          position: "relative",
        }}
      >
        {activeVisible && (
          <div
            className="ease-in-out-back"
            style={{
              width: 8,
              height: "3.25rem",
              position: "absolute",
              right: 0,
              top: activeTop,
              backgroundColor: "#4962df",
            }}
          ></div>
        )}
        {menuItems.map((item, index) => (
          <NavLink
            exact
            to={item.href}
            className="text-decoration-none px-4 py-3 d-block dk-navlink dk-navlink-hover mb-2 ease-in d-flex"
            isActive={(match, location) => {
              if (!match) return false;
              setActiveVisible(true);
              setActiveTop(1 + (3.375 + 0.5) * index + "rem");
              return true;
            }}
            style={{
              fontWeight: 500,
              color: "black",
            }}
          >
            <span className="svg-icon-lg svg-baseline mr-3">{item.icon}</span>
            {item.name}
          </NavLink>
        ))}
      </div>
      <div className="w-100 h-100 overflow-auto" style={{ background: "#f6f6f6" }}>
        <Switch>
          {menuItems.map((item) => (
            <Route exact={item.exact} path={item.href}>
              {item.component}
            </Route>
          ))}
        </Switch>
      </div>
    </>
  );
}
